import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded'
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded'
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded'
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded'
import { Pressable } from '../../../Common/Pressable'

export const CollapsibleHandle = ({
  collapsed,
  axis,
  controls,
  collapseLabel,
  expandLabel,
  onToggle,
}: {
  collapsed: boolean
  axis: 'horizontal' | 'vertical'
  controls: string
  collapseLabel: string
  expandLabel: string
  onToggle: () => void
}) => (
  <Pressable
    className={`analysisChartCollapseHandle analysisChartCollapseHandle--${axis}`}
    onClick={onToggle}
    aria-controls={controls}
    aria-expanded={!collapsed}
    title={collapsed ? expandLabel : collapseLabel}
  >
    {axis === 'horizontal'
      ? (collapsed ? <ChevronLeftRoundedIcon fontSize="inherit" /> : <ChevronRightRoundedIcon fontSize="inherit" />)
      : (collapsed ? <ExpandLessRoundedIcon fontSize="inherit" /> : <ExpandMoreRoundedIcon fontSize="inherit" />)}
    <span>{collapsed ? expandLabel : collapseLabel}</span>
  </Pressable>
)
